// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"333":"epub","962":"home"}[chunkId] || chunkId) + "." + {"333":"7c1d2c21","869":"5bb26aa5","962":"4b84e78f"}[chunkId] + ".chunk.js";
};